import { useEffect, useState } from "react";
import { certGETj } from "lib/API";
import { isDev } from "lib/useful";

const packageJSON = require("../../package.json");

function VersionInfo() {
  const [serverVersion, setServerVersion] = useState(null);
  useEffect(() => {
    certGETj("version").then(setServerVersion);
  }, []);

  return (
    <div className="absolute text-sm left-14 top-10 lg:left-5 text-white opacity-50 z-50 pointer-events-none">
      {isDev() && <span>isDev &mdash; </span>}
      <span>C v{packageJSON.version}</span>
      {serverVersion && <span> &mdash; S v{serverVersion}</span>}
    </div>
  );
}

export default VersionInfo;
